import UsersPage from './UsersListPage';

export const usersRoute = [
  {
    path: '',
    element: <UsersPage />,
  },
];
